import React from 'react'

import { Layout } from '../components/layout'
import SEO from '../components/seo'

import logosheet750 from '../images/logosheet-750.jpg'
import logosheet1440 from '../images/logosheet-1440.jpg'
import badgeBlack from '../images/1D1L-badge-black.svg'
import hashtagLogo from '../images/1D1L-hashtag-logo.svg'
import icon101heart from '../images/icon-101heart.svg'
import iconHeartEyes from '../images/icon-heart-eyes.svg'
import iconHandRight from '../images/icon-hand-right.svg'
import iconOneDollarOneHeart from '../images/icon-one-dollar-one-heart.svg'
import iconCircled from '../images/icon-circled.svg'
import iconFacebook from '../images/icon-facebook.svg'
import iconInstagram from '../images/icon-instagram.svg'
import iconLinkedIn from '../images/icon-linkedin.svg'
import iconTikTok from '../images/icon-tiktok.svg'
import pr1 from '../images/1D1L-PR-1.pdf'

const IndexPage = () => (
  <Layout>
    <SEO title='1Dollar1Love' />

    <section className='icon-text'>
      <div className='container'>
        <div>
          <img className='icon-text__header-image' src={iconHeartEyes} alt='' />
        </div>

        <h2 className='visuallyhidden'>Introduction</h2>

        <p>
          <strong>Join us for the Summer Masked Selfie Challenge.</strong>
          <br />
          Let’s launch this movement and make history together to honor the
          frontline heroes and to help the most vulnerable in need.
        </p>

        <p>
          <strong>Donate</strong> $1
          <br />
          <br />
          <strong>Post</strong> a masked selfie with
          <br />
          #1DOLLAR1LOVE
          <br />
          <br />
          <strong>Share</strong> on social media and tag your friends
        </p>

        <a
          className='donate-cta'
          href='https://app.mobilecause.com/public/peer_fundraisers/558743/peer_fundraiser_donations/new?vid=8l14i'
        >
          Donate Now
        </a>

        <p>
          <strong>1Dollar1Love is partnering with Together Rising</strong>
          <br />
          We feel so lucky to have joined forces with Together Rising. 100% of
          your donations will go to them. Together Rising's goal has always been
          to show how small things, done with great love, can change the world.
        </p>

        <p>
          &ldquo;Every penny Together Rising receives from this campaign will be
          deployed to support hundreds of frontline heroes, individuals and
          families with urgent needs, like groceries and rent, due to the
          devastation caused by the COVID-19 crisis,&rdquo; says Glennon Doyle,
          author, activist and founder of Together Rising. Acting as virtual
          first responders for individuals and families in crisis Together
          Rising is supporting some of the most vulnerable groups, including
          heroic healthcare workers and youth aging out of foster care.
        </p>

        <p>
          During the Summer Masked Selfie Challenge, we’re hoping everyone's
          social feeds will be filled with masked selfies so that the frontline
          + healthcare workers will open their social media and feel the love!
        </p>

        <ul className='social__list'>
          <li className='social__item'>
            <a href='https://www.instagram.com/1dollar1love/'>
              <img src={iconInstagram} alt='Instagram' />
            </a>
          </li>
          <li className='social__item'>
            <a href='https://www.facebook.com/1Dollar1Love-112085350505512'>
              <img src={iconFacebook} alt='Facebook' />
            </a>
          </li>
          <li className='social__item'>
            <a href='https://vm.tiktok.com/K99egA/'>
              <img src={iconTikTok} alt='TikTok' />
            </a>
          </li>
          {/*<li className="social__item"><a href="">Snapchat</a></li>
          <li className="social__item"><a href="">YouTube</a></li>*/}
          <li className='social__item'>
            <a href='https://www.linkedin.com/company/1dollar1love'>
              <img src={iconLinkedIn} alt='LinkedIn' />
            </a>
          </li>
        </ul>

        <p className='text-center'>
          <a href={pr1} target='_blank' rel='noopener noreferrer'>
            View the press release
          </a>
        </p>
      </div>
    </section>

    <section className='logosheet'>
      <picture>
        <source srcSet={logosheet1440} media='(min-width: 750px)' />
        <img src={logosheet750} alt='1Dolla1Love logosheet' />
      </picture>
    </section>

    <section className='icon-text'>
      <div className='container'>
        <div>
          <img className='icon-text__header-image' src={icon101heart} alt='' />
        </div>

        <h2 className='visuallyhidden'>Details</h2>

        <p>
          <strong>1Dollar1Love</strong> is a simple ask of kindness. It’s a
          grassroots movement to bring all people together as one, to take a
          small action to help those in need.
        </p>

        <p>
          Donate a dollar, post a selfie and tell your friends and followers to
          do the same. Our goal is to spread the love or at least a smile.
        </p>

        <a
          className='donate-cta'
          href='https://app.mobilecause.com/public/peer_fundraisers/558743/peer_fundraiser_donations/new?vid=8l14i'
        >
          Donate Now
        </a>

        <p>
          You may think it’s a bit crazy of us to ask for just 1 dollar, but
          we’re hoping that since it’s such a small ask, and so easy to do, many
          will be willing to say yes. If you can just give that spare change in
          your pockets, we have faith that the dollars and the love will all add
          up to something beautiful.
        </p>

        <p>
          All your donations will support organizations and individuals in need.
          We don’t take any cut.
        </p>
      </div>
    </section>

    <section className='icon-hero icon-hero icon-badge bg-green'>
      <img src={badgeBlack} alt='' />
    </section>

    <section className='icon-text icon-text--with-columns'>
      <h2 className='visuallyhidden'>Mission</h2>
      <div className='icon-text__columns'>
        <div className='icon-text__column'>
          <div>
            <img
              className='icon-text__header-image'
              src={iconHandRight}
              alt=''
            />
          </div>
          <p>
            <strong>Unity.</strong> It starts with the love of one person. It’s
            highly infectious. That love spreads, and before you know it, you
            have an entire country of people rallying around one simple action:
            In this case, that one person was the photographer Laurie Frankel.
            While listening to Third World one day during quarantine, she was
            moved by the lyrics &ldquo;Now that we found love what are we gonna
            do with it? Spread it all over.&rdquo;{' '}
            <a href='https://www.instagram.com/explore/tags/1dollar1love/'>
              #1Dollar1Love
            </a>
            .
          </p>
        </div>

        <div className='icon-text__column'>
          <div>
            <img
              className='icon-text__header-image'
              style={{ paddingTop: '1.5rem' }}
              src={iconOneDollarOneHeart}
              alt=''
            />
          </div>
          <p>
            <strong>Let's spread the love.</strong> We are inviting everyone
            &mdash; artists, comedians, chefs, journalists, writers, filmmakers,
            musicians, celebrities, kids, athletes, scientists, executives,
            gamers, news media &mdash; to post masked selfies. As social media
            gets covered with masked selfies, we hope many more will join the
            1Dollar1Love movement.
          </p>
        </div>

        <div className='icon-text__column'>
          <div>
            <img className='icon-text__header-image' src={iconCircled} alt='' />
          </div>
          <p>
            <strong>Helping those in need.</strong> Your 1Dollar1Love donation
            to Together Rising will help support individuals with urgent needs
            arising from the pandemic. It will support the most vulnerable
            groups struggling to pay rent, buy groceries and pay bills following
            job loss during this time.
          </p>
        </div>
      </div>

      <img
        className='icon-text__bottom-img'
        src={hashtagLogo}
        alt='1dollar1love hashtag logo'
      />
    </section>

    <section className='word-stack padding-large bg-purple'>
      <div className='container'>
        <p>
          1 life
          <br />
          1 people
          <br />
          1 planet
          <br />
          1 day
          <br />
          1 dollar
          <br />1 love
        </p>
      </div>
    </section>

    <section className='instagram-feed'>
      <div className='container'>
        <script src='https://snapwidget.com/js/snapwidget.js'></script>
        <div class='instagram-iframe-container'>
          <iframe
            src='https://snapwidget.com/embed/840169'
            class='snapwidget-widget'
            allowtransparency='true'
            frameborder='0'
            scrolling='no'
            title='instagram feed'
            style={{ border: 'none', overflow: 'hidden', width: '100%' }}
          />
        </div>
      </div>
    </section>
  </Layout>
)

export default IndexPage
